import { mapGetters } from 'vuex';

export function OfferState(storeModule) {
  return {
    computed: {
      ...mapGetters(storeModule, ['getOffer']),
      getOsagoBasePrice() {
        return Number(this.getOffer?.pricing?.basePrice) || 0;
      },
      getOsagoDiscountAmount() {
        return Number(this.getOffer?.pricing?.discount?.amount) || 0;
      },
      getAdditionalCoveragePrice() {
        return Number(this.getOffer?.appliedAddons?.additionalCoverage?.meta?.price) || 0;
      },
      getAutolawyerPrice() {
        return Number(this.getOffer?.appliedAddons?.autolawyer?.meta?.price) || 0;
      },
      getTotalBasePrice() {
        return this.getOsagoBasePrice + this.getAdditionalCoveragePrice + this.getAutolawyerPrice;
      },
      getTotalDiscountedPrice() {
        return (this.getOsagoBasePrice - this.getOsagoDiscountAmount) + this.getAdditionalCoveragePrice + this.getAutolawyerPrice;
      },
    },
  };
}
